const attrAutocompleteOff = 'new-password'

/**
 * Mixin, отключающий autocomplete браузера для полей ввода
 */
export const autocompleteOff = {
  props: {
    autocomplete: {
      required: false,
    },
  },
  computed: {
    attrAutocomplete() {
      if (this.autocomplete) {
        return this.autocomplete
      }
      return attrAutocompleteOff
    },
  }
}